var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHotWater = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  strokeLinejoin: "round",
  d: "M27.8 21.2h-15c-.7 0-1.3-.6-1.3-1.3v-.6c0-2.8 2.3-5.1 5.1-5.1H24c2.8 0 5.1 2.3 5.1 5.1v.7c0 .7-.6 1.2-1.3 1.2ZM18.2 12.4h4.2M20.3 9.5V11"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "m15.4 25.1-1-1.3-1 1.3c-.2.2-.3.5-.3.8 0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.4-.2-.6-.3-.8ZM21.3 25.1l-1-1.3-1 1.3c-.2.2-.3.4-.3.7 0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c-.1-.3-.2-.5-.3-.7ZM27.2 25.1l-1-1.3-1 1.3c-.2.2-.3.5-.3.8 0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c-.1-.4-.2-.6-.3-.8ZM18.3 29.4l-1-1.3-1 1.3c-.2.2-.3.5-.3.8 0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.3-.1-.5-.3-.8ZM24.2 29.4l-1-1.3-1 1.3c-.2.2-.3.5-.3.8 0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.3-.1-.5-.3-.8Z"
}))));
export default SvgHotWater;